var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSns4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1625 -3569)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 7",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1625 3569)",
    style: {
      fill: "#303542"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93 -257)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 166",
    width: 20,
    height: 20,
    rx: 6,
    transform: "translate(1728 3836)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 11",
    transform: "translate(1732.455 3840.455)",
    style: {
      stroke: "#303542",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.545,
    cy: 5.545,
    r: 5.545,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.545,
    cy: 5.545,
    r: 4.545,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 12",
    cx: 1.15,
    cy: 1.15,
    r: 1.15,
    transform: "translate(1742.7 3839)",
    style: {
      fill: "#303542"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSns4);
export default __webpack_public_path__ + "static/media/sns_4.fe960ed09463f52c49f4da13caaafa8a.svg";
export { ForwardRef as ReactComponent };